function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.81 14.852l-4.39-1.882a1.496 1.496 0 00-1.424.131l-2.348 1.565a7.176 7.176 0 01-3.3-3.286l1.56-2.383a1.498 1.498 0 00.123-1.412L9.148 3.19a1.503 1.503 0 00-1.561-.899A5.257 5.257 0 003 7.5C3 14.944 9.056 21 16.5 21a5.256 5.256 0 005.209-4.587 1.504 1.504 0 00-.899-1.56z",
    fill: props.fill
  }));
}

export default SvgPhone;